import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { Typography, Box, Paper } from '@material-ui/core';
import Filter from '../../../components/Dashboard/Filter/6level';
import MaterialTable from 'material-table';
import { tableIcons } from '../../../configs/ui/TableConfig';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import {
   graph_mock,
   table_mock,
} from '../../../mockdata/dashboard/mock-graph-1';
import EmptyChart from '../../../components/Dashboard/Chart/EmptyChart';
import { useLocation } from 'react-router-dom';
import DownloadPDFButton from '../../../components/Dashboard/Button/DownloadPDF';
import DownloadExcelButton from '../../../components/Dashboard/Button/DownloadExcel';
import FileSaver from 'file-saver';
import moment from 'moment';

let mock = false;

const PointAndRedeem = () => {
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [isLoadingGraph, setIsLoadingGraph] = useState(false);
   const [isLoadingTable, setIsLoadingTable] = useState(false);
   const [isLoadingExcel, setIsLoadingExcel] = useState(false);
   const [filtersData, setFiltersData] = useState();
   const [tableData, setTableData] = useState([]);
   const [chartData, setChartData] = useState();
   const location = useLocation();
   const getChartsOptionsDefault = () => {
      return {
         tooltip: {
            trigger: 'axis',
            axisPointer: {
               type: 'shadow',
            },
         },
         legend: [
            {
               left: '35%',
               itemWidth: 50,
               itemGap: 15,
               data: [
                  'คะแนน for SOCIETY ที่ได้รับ',
                  'คะแนน with GOVERNANCE ที่ได้รับ',
                  'คะแนน through DIGITALIZATION ที่ได้รับ',
               ],
            },
            {
               top: 25,
               left: '35%',
               itemWidth: 50,
               itemGap: 20,
               data: [
                  'คะแนน for SOCIETY ที่แลก',
                  'คะแนน with GOVERNANCE ที่แลก',
                  'คะแนน through DIGITALIZATION ที่แลก',
               ],
            },
         ],
         grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
         },
         xAxis: [
            {
               name: 'วัน',
               type: 'category',
               data: null,
            },
         ],
         yAxis: [
            {
               name: 'คะแนน',
               type: 'value',
            },
         ],
         series: [
            {
               color: '#EDD221',
               name: 'คะแนน for SOCIETY ที่ได้รับ',
               type: 'bar',
               stack: 'GSB',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               color: '#F383BB',
               name: 'คะแนน with GOVERNANCE ที่ได้รับ',
               type: 'bar',
               stack: 'GSB',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               color: '#633C21',
               name: 'คะแนน through DIGITALIZATION ที่ได้รับ',
               type: 'bar',
               stack: 'GSB',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               color: '#D1F2EB',
               name: 'คะแนน for SOCIETY ที่แลก',
               type: 'bar',
               stack: 'used',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               color: '#1ABC9C',
               name: 'คะแนน with GOVERNANCE ที่แลก',
               type: 'bar',
               stack: 'used',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               color: '#76D7C4',
               name: 'คะแนน through DIGITALIZATION ที่แลก',
               type: 'bar',
               stack: 'used',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
         ],
      };
   };
   const onFiltersSubmit = (filters) => {
      setFiltersData(filters);
      let payload = {
         divisionList: filters.shortCodes,
         startDate: filters.startDateString,
         endDate: filters.endDateString,
      };
      if (mock) {
         setIsLoadingGraph(true);
         setTimeout(() => {
            setIsLoadingGraph(false);
            setChartData(graph_mock.graph);
         }, 100);
      } else {
         setIsLoadingGraph(true);
         Axios.post('/GSB/dashboard/dashboard/GetPointAndRewardGraph', payload)
            .then((resp) => {
               setChartData(resp.data.graph);
               // enqueueSnackbar('ดึงข้อมูลกราฟสำเร็จ', { variant: 'success' });
            })
            .catch((e) => {
               setChartData(null);
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(response.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else console.error('site error');
            })
            .finally(() => {
               setIsLoadingGraph(false);
            });
      }
   };
   const mapOptions = (data) => {
      let xAxisData = data.map((el) => el.dateTimeLabel.split(' ')[0]);
      let G = data.map((el) => el.gTotalReceived);
      let S = data.map((el) => el.sTotalReceived);
      let B = data.map((el) => el.bTotalReceived);
      let GRedeem = data.map((el) => el.gTotalRedeem);
      let SRedeem = data.map((el) => el.sTotalRedeem);
      let BRedeem = data.map((el) => el.bTotalRedeem);
      let options = getChartsOptionsDefault();
      options.xAxis[0].data = xAxisData;
      options.series[0].data = G;
      options.series[1].data = S;
      options.series[2].data = B;
      options.series[3].data = GRedeem;
      options.series[4].data = SRedeem;
      options.series[5].data = BRedeem;
      return options;
   };
   const getTable = () => {
      if (mock) {
         setIsLoadingTable(true);
         setTimeout(() => {
            setTableData(table_mock.rewards);
            setIsLoadingTable(false);
         }, 100);
      } else {
         setIsLoadingTable(true);
         Axios.get('/GSB/dashboard/dashboard/GetTopReward')
            .then((resp) => {
               setTableData(resp.data.rewards);
               // enqueueSnackbar('ดึงข้อมูลตารางสำเร็จ', { variant: 'success' });
            })
            .catch((e) => {
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(e.response.data.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else {
                  console.error('site error');
               }
            })
            .finally(() => {
               setIsLoadingTable(false);
            });
      }
   };
   const handleDownloadExcel = () => {
      setIsLoadingExcel(true);
      Axios.get(`/GSB/dashboard/dashboard/GetTopReward`, {
         responseType: 'blob',
         params: {
            isGenerateReport: true,
         },
      })
         .then((response) => {
            setIsLoadingExcel(false);
            FileSaver.saveAs(
               new Blob([response.data]),
               'ความถี่ของคะแนนที่พนักงานได้รับและการแลกของรางวัล.xlsx',
            );
         })
         .catch((err) => {
            enqueueSnackbar('เกิดข้อผิดพลาด กรุณาตรวจสอบข้อมูล', {
               variant: 'error',
            });
         });
   };
   useEffect(() => {
      getTable();
   }, []);
   return (
      <div>
         <Box margin={'10px 0px'} textAlign={'end'}>
            <DownloadPDFButton
               disabled={isLoadingGraph || isLoadingTable}
               to={() => {
                  localStorage.setItem(
                     'report',
                     JSON.stringify({ filtersData, chartData, tableData }),
                  );
                  return {
                     pathname: location.pathname + '/report',
                  };
               }}
            />
         </Box>
         <Paper>
            <Box padding={'10px'}>
               <Box>
                  <Typography variant='h5'>
                     ความถี่ของคะแนนที่พนักงานได้รับและการแลกของรางวัล
                  </Typography>
                  <Filter
                     isLoading={isLoadingGraph}
                     onSubmit={onFiltersSubmit}
                     defaultSubmitFirstParams
                     startDate={new Date(moment().subtract(6, 'days'))}
                     endDate={new Date()}
                  />
               </Box>
               <Box>
                  {chartData ? (
                     <ReactECharts
                        option={mapOptions(chartData)}
                        style={{ height: 300, width: '100%' }}
                     />
                  ) : (
                     <EmptyChart
                        text={'ไม่มีข้อมูล, โปรดระบุตัวกรองด้านบนเพื่อแสดงกราฟ'}
                        show={true}
                        height={300}
                     />
                  )}
               </Box>
            </Box>

            <Box
               padding={'10px'}
               display={'flex'}
               justifyContent={'space-between'}
               alignItems={'center'}
            >
               <Typography variant='h5'>
                  Top 10 ของรางวัลที่ถูก Redeem
               </Typography>
               <DownloadExcelButton
                  isLoading={isLoadingExcel}
                  onClick={handleDownloadExcel}
               />
            </Box>
            <Box padding={'10px'}>
               <MaterialTable
                  isLoading={isLoadingTable}
                  columns={[
                     {
                        field: 'seq',
                        title: 'ลำดับ',
                        sorting: false,
                        width: 200,
                     },
                     {
                        field: 'rewardNameTh',
                        title: 'รางวัล',
                        sorting: false,
                     },
                     {
                        field: 'categoryNameTh',
                        title: 'ประเภทของรางวัล',
                        sorting: false,
                     },
                     {
                        field: 'qty',
                        title: 'จำนวนที่แลก',
                        sorting: false,
                     },
                  ]}
                  data={tableData}
                  options={{
                     paging: false,
                     showTitle: false,
                     actionsColumnIndex: -1,
                     addRowPosition: 'first',
                     actionsCellStyle: {
                        color: '#ccc',
                     },
                     headerStyle: {
                        fontWeight: 'bold',
                        backgroundColor: '#F6F6F6',
                     },
                     padding: 'dense',
                     pageSize: 10,
                     search: false,
                     toolbar: false,
                  }}
                  localization={{
                     body: {
                        editRow: {
                           deleteText: 'ต้องการลบข้อมูลนี้ใช่หรือไม่?',
                        },
                     },
                     header: { actions: 'ตัวจัดการ' },
                  }}
                  icons={tableIcons}
               />
            </Box>
         </Paper>
      </div>
   );
};

export default PointAndRedeem;
